import * as React from 'react';
import { useState } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import { useHistory } from 'react-router-dom';
import { Col, Input, Row, Spinner } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Afr, getSelectedAfr, loadAfr, resetState, setToImportedAfr } from '../../redux/AfrSlice';
import { resetConceptState } from "../../redux/ConceptSlice";
import { EditEntityQuery, Entity, EntityReportAccessChange, canReportForType, getNameForAfr, getNameForYear, getSelectedEntity, hasNameChange, loadEntity, selectAfrs, selectEntityStateStatus } from '../../redux/EntitySlice';
import { getSelectedEvents, loadEvents } from '../../redux/EventsSlice';
import { getDimensionSectionMap, getReplaceTableFacts, getTableFacts, getTaxonomyType, isDirty } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum, TaxonomyVersionInfo, selectAvailableVersions } from '../../redux/TaxonomyVersionSlice';
import { selectUser } from '../../redux/UserSlice';
import { ValidationContext, getValidationsForAfr, resetValidationState, validateAfr } from '../../redux/ValidationSlice';
import { EntityReference, getEntityNameForCode, selectEntities } from '../../redux/EntitiesSlice';
import utilityHelper from '../../utils/utilityHelper';
import Select from 'react-select';


const AfrSelectorDropDown = (props: any) => {

    //TODOD make component more efficient for better performance

    const history = useHistory();
    const user = useAppSelector(selectUser);
    const selectedEntityLoadStatus = useAppSelector(selectEntityStateStatus);
    const selectedEntity: Entity | null = useAppSelector(getSelectedEntity);
    var entityList: EntityReference[] = useAppSelector(selectEntities);
    const isDirtyInfo: boolean = useAppSelector(isDirty);
    const pendingTableFacts = useAppSelector(getTableFacts);
    const pendingReplaceTableFacts = useAppSelector(getReplaceTableFacts);
    const dMap = useAppSelector(getDimensionSectionMap);
    const userRole = user && user.userProfile ? user.userProfile.role : "ENTITY_USER";
    var tType: TaxonomyTypeEnum | null = useAppSelector(getTaxonomyType);
    const dispatch = useAppDispatch();
    var afrs: Array<Afr> = useAppSelector(selectAfrs);

    const selected: Afr | null = useAppSelector(getSelectedAfr);
    const selectedId = selected ? selected.afrId : "";
    const currentEvents = useAppSelector(getSelectedEvents);
    const availableVersions: TaxonomyVersionInfo[] = useAppSelector(selectAvailableVersions);
    const [selectedYear, setSelectedYear] = useState(tType === TaxonomyTypeEnum.COURT_REPORTING_939 ? 2022 : -1);

    const [notSubmittedReports, setNotSubmittedReports] = useState<Afr[]>(notSubmittedAfrs(selectedEntity, selectedYear));
    const [canReport, setCanReport] = useState<boolean>(true);



    if (props.publicreports && afrs && afrs.length > 0) {
        afrs = afrs.filter(a => a.status === "VERIFIED");
    }

    const [values, setValues] = useState({
        afrId: selectedId
    });

    const [isLoadingAfrYears, setIsLoadingAfrYears] = useState<boolean>(false);

    function isSubmitted(a: Afr): boolean {
        var status: string = a.status.toLowerCase();
        if (status.indexOf("certified") >= 0) {
            return true;
        }
        if (status.indexOf("verified") >= 0) {
            return true;
        }
        if (status.indexOf("primary") >= 0) {
            return true;
        }
        return false;
    }

    function isAllowed(selEntity: Entity, a: Afr, reportAccessFilter: string): boolean {
        if (a.owner && a.owner.code !== selEntity.code) {
            return true;
        }
        if (!selEntity.entityReportAccessChanges || selEntity.entityReportAccessChanges.length === 0) {
            return true;
        }
        var repAccess = selEntity.entityReportAccessChanges.find((rac: EntityReportAccessChange) => rac.state === reportAccessFilter);
        if (repAccess === undefined) {
            return true;
        }
        if (repAccess.value === "TRUE") {
            return true;
        }
        var parts: string[] = repAccess.timestamp.split("-");
        var maxAllowedYear = parseInt(parts[0]);
        if (parts[1] >= "10") {
            maxAllowedYear++;
        }
        return a.year <= maxAllowedYear;
    }
    function matchesTaxonomy(selEntity: Entity, a: Afr, year: number): boolean {

        var result: boolean = false;
        if (a.taxonomyType === tType) {
            switch (tType) {
                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    if (a.year === year) {
                        result = isAllowed(selEntity, a, "COURT_REPORTING_939_ENABLED");;
                    }
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    result = isAllowed(selEntity, a, "COURT_REPORTING_29_ENABLED");
                    break;

                default:
                    result = isAllowed(selEntity, a, "AFR_ENABLED");
                    break;
            }
        }
        return result;
    }
    function compareAfrs(a: Afr, b: Afr) {
        var akey = a.afrId;
        var bkey = b.afrId;
        return bkey.localeCompare(akey);
    }
    const submittedAfrs = function (selEntity: Entity | null, year: number): Afr[] {

        setIsLoadingAfrYears(true);
        if (!selEntity) {
            setIsLoadingAfrYears(false);
            return [];
        }
        var selafrs = selEntity.afrs;
        selafrs = selafrs.filter(a => matchesTaxonomy(selEntity, a, year) && isSubmitted(a)).sort(compareAfrs);
        setIsLoadingAfrYears(false);
        return selafrs;
    }

    const [submittedReports, setSubmittedReports] = useState<Afr[]>([]);

    function notSubmittedAfrs(selEntity: Entity | null, year: number): Afr[] {
        if (!selEntity) {
            return [];
        }
        var selafrs = selEntity.afrs;
        return selafrs.filter(a => matchesTaxonomy(selEntity, a, year) && !isSubmitted(a)).sort(compareAfrs);
    }
    const afrChangeOnStatusAndAudit = function () {
        if (selected) {
            return selected.status + selected.audittype;
        }
        return "";
    }

    const listenSelectedEntityChanged = function () {
        if (selectedEntity) {
            return selectedEntity.code;
        }
        return "";
    }

    const getAliasForAfr = function (afr: Afr): string {
        var alias: string = "";
        if (hasNameChange(selectedEntity)) {
            alias = getNameForYear(selectedEntity, afr.year);
        } else {
            alias = getNameForAfr(selectedEntity, afr);
        }
        if (selectedEntity && alias === selectedEntity.name) {
            return "";
        }
        return "*";
    }

    //TODO change data binding to use entities slice
    const onChangeValue = (event: any) => {
        setValues({ ...values, afrId: event.target.value });
        if (props.publicreports) {
            var afrId = event.target.value;
            var parts = afrId.split("^");
            var afrYear = 2020;
            if (parts.length > 1) {
                afrYear = parseInt(parts[1]);
            }
            dispatch(setToImportedAfr({ afrId: afrId, year: afrYear, status: "REPORT_MODE", owner: { name: getEntityNameForCode(entityList, parts[0]), code: parts[0] } }));
        } else {
            dispatch(resetValidationState());
            dispatch(loadAfr(event.target.value));
            dispatch(loadEvents(event.target.value));
            dispatch(resetConceptState({}));
            if (!props.publicreports) {
                var firstLocation: string = "";
                switch (tType) {
                    case TaxonomyTypeEnum.AFR:
                        firstLocation = "/AfrSummary";
                        break;

                    case TaxonomyTypeEnum.COURT_REPORTING_939:
                        firstLocation = "/CourtReporting939Admin";
                        break;

                    case TaxonomyTypeEnum.COURT_REPORTING_29:
                        firstLocation = "/CR29Admin";
                        break;
                }
                if (userRole === "ADMIN") {
                    history.push(firstLocation + "A");
                } else {
                    history.push(firstLocation);
                }
            }
        }
    }

    React.useEffect(() => {
        dispatch(resetValidationState());
        if (selected) {
            if (selectedEntity) {
                if (tType === 'AFR') {
                    //                    setValues({ afrId: `${selectedEntity.code}^${selected.year.toString()}` })
                    setValues({ afrId: `${selected.afrId}` })
                } else {
                    setValues({ afrId: `${selected.afrId}` })
                }

                const vc: ValidationContext = {
                    afr: selected,
                    entity: selectedEntity,
                    afrEvents: currentEvents,
                    pendingTableFacts: pendingTableFacts,
                    pendingReplaceTableFacts: pendingReplaceTableFacts,
                    dimensionSectionMap: dMap
                };
                /* check if there are error to notify */
                var errors = getValidationsForAfr(vc);
                if (errors && errors.length > 0) {
                    dispatch(validateAfr(vc));
                }
            }
        }
    }, [selected, selectedYear])

    React.useEffect(function () {
        if (selectedEntity) {
            if (!props.publicreports) {
                // This is to refresh in redux the AFRs array when a change is made in the AFR
                var tYear: number = selected ? selected.year : -1;
                var eQuery: EditEntityQuery = {
                    entityId: selectedEntity.code,
                    taxonomyYear: tYear
                }
                dispatch(loadEntity(eQuery));
            }
        }
    }, [afrChangeOnStatusAndAudit()]);

    React.useEffect(function () {
        if (selectedEntity) {
            setCanReport(canReportForType(selectedEntity, tType));
            setSubmittedReports(submittedAfrs(selectedEntity, selectedYear));
            setNotSubmittedReports(notSubmittedAfrs(selectedEntity, selectedYear));

        } else {
            setCanReport(true);
            setSubmittedReports([]);
            setNotSubmittedReports([]);
        }
    }, [selectedEntity]);

    React.useEffect(function () {

        dispatch(resetState({}));
        setValues({ ...values, afrId: "" });
        var selYear = 2011;
        if (afrs && afrs.length > 0) {
            afrs.map(a => {
                if (a.year > selYear) {
                    selYear = a.year;
                }
            });
        } else {
            selYear = new Date().getFullYear();
        }
        setSelectedYear(selYear);
        setSubmittedReports(submittedAfrs(selectedEntity, selYear));
        setNotSubmittedReports(notSubmittedAfrs(selectedEntity, selYear));

    }, [listenSelectedEntityChanged()]);

    return (
        <React.Fragment>            
            <Row>
                <Col md="12">
                    <Spinner children={''} style={{ width: '1rem', height: '1rem' }}
                        type="grow" color="warning"
                        hidden={selectedEntityLoadStatus != "loadEntityData"} />
                    <div hidden={selectedEntityLoadStatus == 'loadEntityData'}>
                        <Select
                            isSearchable={true}
                            isDisabled={isDirtyInfo}
                            value={submittedReports
                                .filter(afr => afr.status.toLowerCase() === "verified")
                                .map(afr => ({
                                    value: afr.afrId,
                                    label: `${afr.year} ${getAliasForAfr(afr)}`
                                }))
                                .find(option => option.value === values.afrId) || null
                            }
                            onChange={(selectedOption: any) => {
                                if (selectedOption) {
                                    // Mimic radio button onChangeValue
                                    onChangeValue({ target: { value: selectedOption.value } });
                                }
                            }}
                            options={submittedReports
                                .filter(afr => afr.status.toLowerCase() === "verified")
                                .map(afr => ({
                                    value: afr.afrId,
                                    label: `${afr.year} ${getAliasForAfr(afr)}`
                                }))
                            }
                        />
                    </div>
                </Col>
            </Row>                               
        </React.Fragment>
    )
}

export default AfrSelectorDropDown;